import { render, staticRenderFns } from "./ResourceSearch.vue?vue&type=template&id=3ab097ca&scoped=true"
import script from "./ResourceSearch.vue?vue&type=script&lang=js"
export * from "./ResourceSearch.vue?vue&type=script&lang=js"
import style0 from "./ResourceSearch.vue?vue&type=style&index=0&id=3ab097ca&prod&scoped=true&lang=scss"
import style1 from "./ResourceSearch.vue?vue&type=style&index=1&id=3ab097ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab097ca",
  null
  
)

export default component.exports